// @nexusmods/fomod-installer-ipc stand-in. The renderer subclasses
// BaseIPCConnection at module scope, so the export must be a constructible
// class even though FOMOD installer IPC is fused off in the web build.
const { EventEmitter } = require("events");

class BaseIPCConnection extends EventEmitter {
    connect() {
        return Promise.reject(
            new Error("FOMOD installer IPC is fused off in the web build"),
        );
    }
    disconnect() {
        return Promise.resolve();
    }
    dispose() {}
    send() {
        return Promise.reject(
            new Error("FOMOD installer IPC is fused off in the web build"),
        );
    }
    invoke() {
        return Promise.reject(
            new Error("FOMOD installer IPC is fused off in the web build"),
        );
    }
    isConnected() {
        return false;
    }
}

module.exports = {
    BaseIPCConnection,
};
